export interface listenkeyResponse {
    listenKey: string;
}